export default function useUserflow() {
  /**
   * Get the user id you will pass to Userflow
   * @returns {*}
   */
  function getUserflowUserId(user) {
    return `${window.keyprod.env}_${window.tenant.name}_${user.id}`;
  }

  /**
   * Get the user attributes you will pass to Userflow
   * @param user
   * @returns {{signed_up_at: *, name, email}}
   */
  function getUserflowUserAttributes(user) {
    return {
      email: user.email,
      name: user.fullName,
      signed_up_at: user.firstLogin,
      env: window.keyprod.env,
      tenant: window.tenant.name,
      role: user.access_code,
      language: user.language,
    };
  }

  /**
   * Get the tenant attributes you will pass to Userflow
   * @returns {{tenant}}
   */
  function getTenantAttributes() {
    return {
      tenant: window.tenant.name,
    };
  }

  /**
   * Returns true if Userflow is enabled
   * @returns {*|boolean}
   */
  function isUserflowEnabled() {
    return window.keyprod.USERFLOW_KEY && window.keyprod.USERFLOW_KEY !== '' && !window.Cypress;
  }

  return {
    getUserflowUserId, getUserflowUserAttributes, getTenantAttributes, isUserflowEnabled,
  };
}
